import { useQuery } from "react-query";
import { getHomeCompanies } from "actions/Employees";

export const useGetHomeCompanies = () => {
  return useQuery("GetHomeCompanies", getHomeCompanies, {
    refetchOnWindowFocus: false,
  });
};
